module.exports = __webpack_public_path__ + "img/file-arrow-down-solid.cc69e9e2.svg";